export default __webpack_public_path__ + "2299d9914bda7e14f0955cd60e07e5a6.png";